import React from 'react'

function ArrowDownNew({ color = '#141414' }: { color?: string }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.13003 5.16367C2.31578 4.95934 2.63201 4.94428 2.83633 5.13003L8 9.99997L13.1637 5.13003C13.368 4.94428 13.6842 4.95934 13.87 5.16367C14.0557 5.368 14.0407 5.68422 13.8363 5.86997L8.67267 10.7399C8.29125 11.0867 7.70875 11.0867 7.32733 10.7399L2.16366 5.86997C1.95933 5.68422 1.94427 5.368 2.13003 5.16367Z'
        fill={color}
      />
    </svg>
  )
}

export default ArrowDownNew
